import { defineComponent as w, ref as h, watch as B, createElementBlock as d, openBlock as u, mergeProps as V, unref as t, createCommentVNode as m, createElementVNode as c, normalizeClass as p, createVNode as r, withCtx as f, toDisplayString as E } from "vue";
import n from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Pagination/pagination.js";
import P from "../Button.vue2.js";
import D from "../TextInput.vue2.js";
import { AngleLeftIcon as G } from "../../packages/icons/dist/esm/icons/angle-left-icon.js";
import { AnglesLeftIcon as S } from "../../packages/icons/dist/esm/icons/angles-left-icon.js";
import { AngleRightIcon as F } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { AnglesRightIcon as R } from "../../packages/icons/dist/esm/icons/angles-right-icon.js";
import { useOUIAProps as U } from "../../helpers/ouia.js";
import { pluralize as $ } from "../../util.js";
const z = ["aria-label"], H = { "aria-hidden": "true" }, Z = /* @__PURE__ */ w({
  name: "PfPaginationNavigation",
  __name: "PaginationNavigation",
  props: {
    disabled: { type: Boolean },
    compact: { type: Boolean },
    page: { default: 0 },
    lastPage: { default: 0 },
    firstPage: { default: 0 },
    perPage: { default: 10 },
    pagesTitle: {},
    pagesTitlePlural: {},
    toLastPageAriaLabel: { default: "Go to last page" },
    toNextPageAriaLabel: { default: "Go to next page" },
    toFirstPageAriaLabel: { default: "Go to first page" },
    toPreviousPageAriaLabel: { default: "Go to previous page" },
    currPageAriaLabel: { default: "Current page" },
    paginationAriaLabel: { default: "Pagination" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["first-click", "previous-click", "next-click", "last-click", "set-page"],
  setup(v, { emit: k }) {
    const e = v, A = U({ id: e.ouiaId, safe: e.ouiaSafe }), s = k, o = h(e.page);
    B(() => e.page, (a) => o.value = a, { immediate: !0 });
    function g(a) {
      const l = (a - 1) * e.perPage, i = a * e.perPage;
      s("set-page", a, e.perPage, l, i);
    }
    function b(a, l) {
      let i = typeof a == "number" ? a : parseInt(a, 10);
      return isNaN(i) || (i = i > l ? l : i, i = i < 1 ? 1 : i), i;
    }
    function N(a) {
      const l = [
        "Tab",
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
        "ArrowUp",
        "ArrowDown"
      ];
      if (a.key === "Enter") {
        const i = b(o.value, e.lastPage);
        g(isNaN(i) ? e.page : i);
      } else !/^\d*$/.test(a.key) && !l.includes(a.key) && a.preventDefault();
    }
    function L(a) {
      if (!(a.currentTarget instanceof HTMLInputElement))
        return;
      const l = b(a.currentTarget.value, e.lastPage);
      o.value = isNaN(l) ? a.currentTarget.value : l;
    }
    function y() {
      s("first-click", 1), o.value = 1, g(1);
    }
    function C() {
      const a = e.page - 1 >= 1 ? e.page - 1 : 1;
      s("previous-click", a), o.value = a, g(a);
    }
    function T() {
      const a = e.page + 1 <= e.lastPage ? e.page + 1 : e.lastPage;
      s("next-click", a), o.value = a, g(a);
    }
    function I() {
      s("last-click", e.lastPage), o.value = e.lastPage, g(e.lastPage);
    }
    return (a, l) => (u(), d("nav", V(t(A), {
      class: t(n).paginationNav,
      "aria-label": a.paginationAriaLabel
    }), [
      a.compact ? m("", !0) : (u(), d("div", {
        key: 0,
        class: p([t(n).paginationNavControl, t(n).modifiers.first])
      }, [
        r(P, {
          variant: "plain",
          disabled: a.disabled || a.page === a.firstPage || a.page === 0,
          "aria-label": a.toFirstPageAriaLabel,
          "data-action": "first",
          onClick: y
        }, {
          default: f(() => [
            r(t(S))
          ]),
          _: 1
        }, 8, ["disabled", "aria-label"])
      ], 2)),
      c("div", {
        class: p(t(n).paginationNavControl)
      }, [
        r(P, {
          variant: "plain",
          disabled: a.disabled || a.page === a.firstPage || a.page === 0,
          "aria-label": a.toPreviousPageAriaLabel,
          "data-action": "previous",
          onClick: C
        }, {
          default: f(() => [
            r(t(G))
          ]),
          _: 1
        }, 8, ["disabled", "aria-label"])
      ], 2),
      a.compact ? m("", !0) : (u(), d("div", {
        key: 1,
        class: p(t(n).paginationNavPageSelect)
      }, [
        r(D, {
          modelValue: o.value,
          "onUpdate:modelValue": l[0] || (l[0] = (i) => o.value = i),
          "aria-label": a.currPageAriaLabel,
          type: "number",
          disabled: a.disabled || a.page === a.firstPage && a.page === a.lastPage || a.page === 0,
          "auto-validate": !1,
          min: a.lastPage <= 0 && a.firstPage <= 0 ? 0 : 1,
          max: a.lastPage,
          onKeydown: N,
          onChange: L
        }, null, 8, ["modelValue", "aria-label", "disabled", "min", "max"]),
        c("span", H, "of " + E(a.pagesTitle ? t($)(a.lastPage, a.pagesTitle, a.pagesTitlePlural) : a.lastPage), 1)
      ], 2)),
      c("div", {
        class: p(t(n).paginationNavControl)
      }, [
        r(P, {
          variant: "plain",
          disabled: a.disabled || a.page === a.lastPage,
          "aria-label": a.toNextPageAriaLabel,
          "data-action": "next",
          onClick: T
        }, {
          default: f(() => [
            r(t(F))
          ]),
          _: 1
        }, 8, ["disabled", "aria-label"])
      ], 2),
      a.compact ? m("", !0) : (u(), d("div", {
        key: 2,
        class: p([t(n).paginationNavControl, t(n).modifiers.last])
      }, [
        r(P, {
          variant: "plain",
          disabled: a.disabled || a.page === a.lastPage,
          "aria-label": a.toLastPageAriaLabel,
          "data-action": "last",
          onClick: I
        }, {
          default: f(() => [
            r(t(R))
          ]),
          _: 1
        }, 8, ["disabled", "aria-label"])
      ], 2))
    ], 16, z));
  }
});
export {
  Z as default
};
